export const BACKEND_URL =
  process.env.NEXT_PUBLIC_API_URL || 'https://api.mentorfy.io/api/v1'

/** Same-origin Next rewrite to the backend (see next.config.ts). */
export const SAME_ORIGIN_API_PROXY = '/api/v1'

const PROXY_FALLBACK_KEY = 'mentorfy:api-via-proxy'

let proxyFallbackActive = false

/**
 * The browser calls the backend directly: on Vercel every byte that crosses the
 * `/api/v1` rewrite is billed as Fast Origin Transfer. Each white-label domain
 * must be allowed by the backend CORS (custom_domain); if the browser blocks a
 * call anyway (domain just connected, CORS cache stale), `switchToApiProxy`
 * switches this tab to the same-origin proxy. Local dev always uses the proxy.
 */
export function resolveClientBackendBaseURL(): string {
  if (typeof window === 'undefined') {
    return BACKEND_URL.replace(/\/$/, '')
  }

  if (process.env.NODE_ENV === 'development' || isApiProxyFallbackActive()) {
    return SAME_ORIGIN_API_PROXY
  }

  return BACKEND_URL.replace(/\/$/, '')
}

function isApiProxyFallbackActive(): boolean {
  if (proxyFallbackActive) return true
  try {
    proxyFallbackActive = window.sessionStorage.getItem(PROXY_FALLBACK_KEY) === '1'
  } catch {
    // storage unavailable: keep the in-memory flag only
  }
  return proxyFallbackActive
}

/** Routes the rest of this tab's session through the same-origin proxy. */
export function switchToApiProxy(): void {
  proxyFallbackActive = true
  try {
    window.sessionStorage.setItem(PROXY_FALLBACK_KEY, '1')
  } catch {
    // storage unavailable: the in-memory flag still covers this page load
  }
}
